export default "__VITE_ASSET__B4M5mAhK__"